import {
  DefaultPortModel, DefaultPortModelOptions,
} from '@projectstorm/react-diagrams';
import { LinkModel } from '../link/LinkModel';
import PortTypes from '../PortTypes';

export class PortModel extends DefaultPortModel {
  constructor(options: DefaultPortModelOptions) {
    super(
      {
        type: PortTypes.basePort,
        ...options
      });
  }

  // @ts-ignore
  createLinkModel(): LinkModel | null {
    return new LinkModel();
  }
}
